import type { FC } from 'react';

import {
  GOALKEEPER_ID,
  DEFENDER_ID,
  MIDFIELDER_ID,
  FORWARD_ID,
} from './constants';

import { Tags } from '@/components';
import type { KeysOf } from '@/types';
import { PLAYER_POSITION_BY_ID, POSITIONS_LABELS } from '@/utils';

type PositionKey = KeysOf<typeof PLAYER_POSITION_BY_ID>;

type Props = {
  isDisabledPositionButton: (positionKey: PositionKey) => boolean | undefined;
  handleIsChecked: (positionKey: PositionKey) => boolean;
  handleSelectPositionButton: (positionKey: PositionKey) => void;
};

const ButtonsTagsPositions: FC<Props> = ({
  isDisabledPositionButton,
  handleIsChecked,
  handleSelectPositionButton,
}) => {
  const { Checkbox } = Tags;
  const { ARQ, DEF, VOL, DEL } = POSITIONS_LABELS.abbreviation;

  return (
    <div className="flex gap-4">
      <Checkbox
        className="flex-1"
        disabled={isDisabledPositionButton(GOALKEEPER_ID)}
        isChecked={handleIsChecked(GOALKEEPER_ID)}
        onClick={() => handleSelectPositionButton(GOALKEEPER_ID)}
      >
        {ARQ}
      </Checkbox>
      <Checkbox
        className="flex-1"
        disabled={isDisabledPositionButton(DEFENDER_ID)}
        isChecked={handleIsChecked(DEFENDER_ID)}
        onClick={() => handleSelectPositionButton(DEFENDER_ID)}
      >
        {DEF}
      </Checkbox>
      <Checkbox
        className="flex-1"
        disabled={isDisabledPositionButton(MIDFIELDER_ID)}
        isChecked={handleIsChecked(MIDFIELDER_ID)}
        onClick={() => handleSelectPositionButton(MIDFIELDER_ID)}
      >
        {VOL}
      </Checkbox>
      <Checkbox
        className="flex-1"
        disabled={isDisabledPositionButton(FORWARD_ID)}
        isChecked={handleIsChecked(FORWARD_ID)}
        onClick={() => handleSelectPositionButton(FORWARD_ID)}
      >
        {DEL}
      </Checkbox>
    </div>
  );
};

export default ButtonsTagsPositions;
